export default "__VITE_ASSET__5fba494e__"